import { useRef } from "react";
import { Divider, GoogleButton, StyledAuth } from "./style";
import { MyButton, MyText } from "../../components";
import { Col, Flex, Input, Row, message, Grid } from "antd";
import { LogoIcon } from "../../assets";
import { useState, useEffect, useCallback } from "react";
import { KeyOutlined, MailOutlined, PhoneOutlined, GoogleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { LANG_KEY } from "../../utils/constants/language";
import { MySegmented } from "../../components";
import { useNavigate } from 'react-router-dom';
import { useDispatch , useSelector} from 'react-redux';
import {useTranslation} from "react-i18next";
import {fetchAuth, fetchModules, ROUTE_PATH, selectStore, setRefreshTokenCookie } from "../../utils/"
import { useLang } from "../../utils/context/lang";
import ReCAPTCHA from "react-google-recaptcha";
import { COOKIE_KEY } from "../../utils/";
import {Cookies} from "react-cookie";
import InputMask from "react-input-mask";
import { useEmbeddedLink } from "../../utils/context/embed";
import { setTokenCookie } from "../../utils/";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import styled from "styled-components";

const FORM_NAME = {
  email: 'email',
  phone: 'phone',
};

const GOOGLE_CLIENT_ID =
  "31515366478-1jkjommo51mms631cc1k05lbk2hger0m.apps.googleusercontent.com";

function openGoogleOAuth(callback: (credential: string) => void) {
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: `${window.location.origin}/auth/google/callback`,
    response_type: "token id_token",
    scope: "openid email profile",
    nonce: Math.random().toString(36).slice(2),
    prompt: "select_account",
  });

  const url = `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
  const popup = window.open(url, "googleAuth", "width=500,height=600,scrollbars=yes");

  const handler = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return;
    if (event.data?.type === "GOOGLE_AUTH" && event.data?.id_token) {
      window.removeEventListener("message", handler);
      popup?.close();
      callback(event.data.id_token);
    }
  };
  window.addEventListener("message", handler);

  const timer = setInterval(() => {
    try {
      if (!popup || popup.closed) {
        clearInterval(timer);
        window.removeEventListener("message", handler);
        return;
      }
      const hash = popup.location.hash;
      if (hash) {
        const hashParams = new URLSearchParams(hash.replace("#", ""));
        const idToken = hashParams.get("id_token");
        if (idToken) {
          clearInterval(timer);
          window.removeEventListener("message", handler);
          popup.close();
          callback(idToken);
        }
      }
    } catch {
    }
  }, 500);
}

export const AuthPage = () => {
  const {t} = useTranslation("common")
  const {profile: {userProfile: userProfileState}} = useSelector(selectStore)
  const {handleChangeLang, lang} = useLang()
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [currentKey, setCurrentKey] = useState<string>(FORM_NAME.email);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const embeddedLink = useEmbeddedLink();

  const cookies = new Cookies()
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);

  const recaptchaRef = useRef<ReCAPTCHA>(null);  
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);  

  const handleCaptchaChange = (token: string | null) => {  
    setCaptchaToken(token);  
  };  

  useEffect(() => {
    let formattedPhone = phone;
    if (phone.startsWith("8")) {
      formattedPhone = "+7" + phone.slice(1);
    }
    const cleanedPhone = formattedPhone.replace(/\D/g, "");
    const isEmailValid = email.includes("@");
    const isPhoneValid = cleanedPhone.startsWith("7") && cleanedPhone.length === 11;
    const isPasswordFilled = password.length > 0;
    if (
      (currentKey === FORM_NAME.email && isEmailValid && isPasswordFilled) ||
      (currentKey === FORM_NAME.phone && isPhoneValid && isPasswordFilled)
    ) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [email, phone, password, currentKey]);

  const handleChangeLangSelect = useCallback((value: any) => {
    handleChangeLang(value)
  }, [])

  const handleLogin = async () => {
    try {
      let username = currentKey === FORM_NAME.email ? email : phone;
      if (currentKey === FORM_NAME.phone) {
        username = phone.replace(/\D/g, "");
        username = `${username}`; 
      }
      await dispatch(fetchAuth({ username, password }));
    } catch (error) {}
  };

  const API_BASE_AUTH = process.env.REACT_APP_AUTH;

  const handleGoogleLogin = () => {
    setIsGoogleLoading(true);
    openGoogleOAuth(async (id_token) => {
      try {
        const res = await fetch(`${API_BASE_AUTH}/rest/v1/user/google-auth`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id_token }),
        });
        const data = await res.json();

        if (data.status === "success") {
          setTokenCookie(data.access_token);
          setRefreshTokenCookie(data.refresh_token);
          if (data.is_new_user) {
            message.success(t("welcomeNewUser") || "Добро пожаловать! 🎉");
          }
          window.location.href = "/";
        } else {
          message.error(data.message || t("registrationError"));
        }
      } catch {
        message.error(t("registrationError"));
      } finally {
        setIsGoogleLoading(false);
      }
    });
  };

  useEffect(() => {
    if (userProfileState?.data?.message && userProfileState?.data?.status === "error") {
      message.error(userProfileState.data.message);
    }
  }, [userProfileState]);

  useEffect(() => {
    if (userProfileState?.success && !userProfileState?.loading && token) {
      embeddedNavigate('/');
    }
  }, [userProfileState, token]);

  return (
    <StyledAuth>
      <div style={{ position: 'absolute', top: screens.xs ? 15: 40, right: 40 }}>
        <MySegmented
          onChange={(value) => handleChangeLangSelect(value)}
          value={lang}
          options={[
            { label: 'ҚАЗ', value: LANG_KEY.KZ },
            { label: 'РУС', value: LANG_KEY.RU },
          ]}
        />
      </div>

      <Flex justify="center" align="center" style={{ width: 500 }}>
        <Row justify="center" gutter={[16, 16]}>
          <Col>
            <Link to={embeddedLink(ROUTE_PATH.MAIN)} style={{ display: 'flex' }}>
              <LogoIcon />
            </Link>
          </Col>

          <Col>
            <MyText size={screens.xs ? 15 : 20} lineHeight={screens.xs ? '20px' : '32px'}>
              {t("happyToHaveYou")} ❤️
            </MyText>
          </Col>

          <Col span={24}>
            <Row justify="center">
              <Col>
                <MySegmented
                  onChange={(value) => setCurrentKey(value)}
                  type="primary"
                  options={[
                    { label: `${t("email")}`, value: FORM_NAME.email },
                    { label: `${t("phone")}`, value: FORM_NAME.phone },
                  ]}
                />
              </Col>
            </Row>
          </Col>

          <Col span={24}>
            <Row gutter={[0, 16]}>
              {currentKey === FORM_NAME.email ? (
                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    Email
                  </MyText>
                  <Input
                    prefix={<MailOutlined style={{ color: '#969BAB', marginRight: 8 }} />}
                    placeholder={t("enterEmail")}
                    value={email}
                    style={{ marginTop: 8 }}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Col>
              ) : (
                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    {t("phone")}
                  </MyText>
                  <InputMask
                    mask="+7 (799) 999-99-99"
                    value={phone}
                    style={{ marginTop: 8 }}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, "").slice(1, 11);
                      setPhone(`+7 (${rawValue.slice(0, 3)}) ${rawValue.slice(3, 6)}-${rawValue.slice(6, 8)}-${rawValue.slice(8, 10)}`);
                    }}
                    maskChar=""
                  >
                    {(inputProps) => (
                      <Input
                        {...inputProps}
                        name="phone"
                        prefix={<PhoneOutlined style={{ color: "#969BAB", marginRight: 8 }} />}
                        placeholder="+7 (777) 777-77-77"
                      />
                    )}
                  </InputMask>
                </Col>
              )}

              <Col span={24}>
                <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                  {t("password")}
                </MyText>
                <Input.Password
                  prefix={<KeyOutlined style={{ color: '#969BAB', marginRight: 8 }} />}
                  style={{ marginTop: 8 }}
                  placeholder={t("enterPassword")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Col>

              <Col span={24}>
                <Flex justify="end">
                  <Link to={embeddedLink("/auth/restore")}>
                    <MyText color="rgba(0, 141, 210, 1)" size={screens.xs ? 16 : 20} lineHeight={screens.xs ? '20px' : '32px'}>
                      {t("forgotPassword")}
                    </MyText>
                  </Link>
                </Flex>
              </Col>

              <Col span={24}>
                <MyButton
                  type="primary"
                  htmlType="submit"
                  color="orange"
                  style={{ width: '100%', fontSize: '18px' }}
                  onClick={handleLogin}
                  disabled={isButtonDisabled}
                >
                  {t("accountLogin")}
                </MyButton>
              </Col>

              <Col span={24}>
                <Divider>{t("orLoginWith") || "или"}</Divider>
              </Col>

              <Col span={24}>
                <GoogleButton onClick={handleGoogleLogin} disabled={isGoogleLoading}>
                  <GoogleOutlined style={{ color: "#4285F4" }} />
                  {isGoogleLoading
                    ? (t("loading") || "Загрузка...")
                    : (t("loginWithGoogle") || "Войти через Google")}
                </GoogleButton>
              </Col>

              <Col span={24}>
                <Flex justify="center">
                  <Col span={12}>
                    <MyText color="#0A033C" size={screens.xs ? 16 : 20} lineHeight={screens.xs ? '20px' : '32px'}>
                      {t("noAccount")}
                    </MyText>
                  </Col>
                  <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Link to={embeddedLink("/register")}>
                      <MyText color="rgba(0, 141, 210, 1)" size={screens.xs ? 16 : 20} style={{ marginLeft: screens.xs ? 0 : 5 }} lineHeight={screens.xs ? '20px' : '32px'}>
                        {t("signUp")}
                      </MyText>
                    </Link>
                  </Col>
                </Flex>
              </Col>
            </Row>
          </Col>
        </Row>
      </Flex>
    </StyledAuth>
  );
};
